export enum NotesType {
  CCIM_NOTE = 1,
  CHASE_NOTE = 2,
  CONTRACTOR_NOTE = 3,
  OTHER_NOTE = 4,
}
